import React, { useState, useEffect } from "react";

const SERVICE_TERMS = {
  "Measurement Service": {
    title: "Measurement Service Terms and Conditions",
    sections: [
      {
        heading: "Measurement Accuracy",
        content:
          "Plan accuracy depends on access to all areas during measurement. Any hidden elements found after removing the old kitchen will be reviewed with your design specialist. IKEA is not responsible for damages to concealed/undisclosed pipes, wiring, gas.",
      },
      {
        heading: "Service Scope",
        content:
          "IKEA measurement service includes key dimensions and service points, but excludes dismantling, structural work, and utility inspections.",
      },
      {
        heading: "Responsibility & Liability",
        content:
          "Any changes made to the space after the measurement may result in design changes and delivery and installation delays.",
      },
      {
        heading: "Use of Data",
        content:
          "By booking this service, you agree that IKEA may use measurement data and photos of your space to support accurate and tailored kitchen planning and services.",
      },
      {
        heading: "Rescheduling and Cancelations",
        content:
          "To reschedule or cancel, please contact IKEA at least 48 hours in advance. The service is prepaid and refundable only under IKEA's refund and cancellation policy.",
      },
    ],
  },
  "Interior Design Service": {
    title: "Interior Design Service Terms and Conditions",
    sections: [
      {
        heading: "Service Overview",
        content:
          "The Interior Design briefing session is a one-hour consultation with an IKEA Interior Design specialist. During this session, you will discuss your space, lifestyle, and design aspirations.",
      },
      {
        heading: "Scope of Service",
        content:
          "This service covers an initial briefing session only. Detailed design proposals, room layouts, and product recommendations are provided in follow-up sessions and are subject to separate agreements.",
      },
      {
        heading: "Preparation",
        content:
          "Please bring measurements, photos of your existing space, and any inspiration references. Accurate information helps our specialist provide the most relevant advice.",
      },
      {
        heading: "Cancellation and Rescheduling",
        content:
          "To reschedule or cancel, please contact IKEA at least 48 hours in advance. The service fee is prepaid and refundable only under IKEA's standard refund and cancellation policy.",
      },
      {
        heading: "Use of Information",
        content:
          "Information shared during the session may be used by IKEA to tailor design recommendations. Photos or measurements provided will not be shared with third parties without your consent.",
      },
    ],
  },
  "Kitchen Planning Service": {
    title: "Kitchen Planning Service Terms and Conditions",
    sections: [
      {
        heading: "Be Prepared to Discuss:",
        list: [
          "Cooking habits and lifestyle",
          "Storage needs and appliance preferences",
          "Design style and color preferences",
          "Budget expectations",
          "Layout and functionality confirmation (Once design is complete)",
          "Ask questions and clarify doubts",
        ],
      },
      {
        heading: "Reviewing and Signing the IKEA Kitchen T&C and Design Notes.",
        list: [
          "Any agreements made regarding design and functionality",
          "Delivery & Installation timelines",
          "Delivery & Installation requirements",
          "Guarantee and after-sales process",
        ],
        extra:
          "This confirms understanding of the listed points.",
      },
      {
        heading: "Post-Service Reference",
        content:
          "Keep a copy of the final design, order, and T's&C's for reference during delivery and installation.",
      },
    ],
  },
};

export default function TermsAndConditionsPage({
  onTermsAcceptedChange,
  serviceType,
}) {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const serviceName = serviceType?.ServiceName;

  useEffect(() => {
    onTermsAcceptedChange?.(termsAccepted);
  }, [termsAccepted, onTermsAcceptedChange]);

  const currentTerms =
    SERVICE_TERMS[serviceName] ||
    (serviceName?.toLowerCase().includes('interior design') ? SERVICE_TERMS["Interior Design Service"] : null) ||
    SERVICE_TERMS["Measurement Service"];

  return (
    <div className="terms-page">
      <h2>{currentTerms.title}</h2>
      <p>
        <strong>Last Updated:</strong> July 2025
      </p>

      {currentTerms.sections.map((section, index) => (
        <React.Fragment key={index}>
          <h4>{section.heading}</h4>
          {section.content && <p>{section.content}</p>}
          {section.list && (
            <ul>
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          {section.extra && <p className="section-extra">{section.extra}</p>}
        </React.Fragment>
      ))}

      <p>
        For questions or support, contact{" "}
        <a href="mailto:festivalcity@ikea.com">festivalcity@ikea.com</a> or call{" "}
        <a href="tel:8004532">800 4532</a>.
      </p>

      <div className="terms-actions">
        <label>
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />{" "}
          I accept the Terms and Conditions
        </label>
      </div>
    </div>
  );
}
